/* Tiki Smuggler front-end interactions (vanilla, dependency-free) */
(function () {
  'use strict';

  /* ---- Mobile nav drawer ---- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  if (toggle && drawer) {
    var open = function () { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('open'); document.body.style.overflow = ''; };
    toggle.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.matches('[data-drawer-close], .drawer__scrim, .drawer__panel a')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Header shadow on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.style.boxShadow = window.scrollY > 12 ? '0 10px 30px -22px rgba(31,21,12,.6)' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 80 + 'ms';
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
})();
